/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */
function safeJoin(input, delimiter) {
    if (!Array.isArray(input)) {
        return '';
    }
    var output = [];
    for (var i = 0; i < input.length; i++) {
        var value = input[i];
        try {
            output.push(String(value));
        }
        catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
function ETrackerPluginConsole(etracker, config) {
    if (config === void 0) { config = {}; }
    config = Object.assign({}, etracker.getConfig('plugin_console') || {}, config);
    var enabled = config.auto;
    var levels = config.levels || ['debug', 'info', 'warn', 'error', 'log', 'assert', 'trace'];
    levels.forEach(function (level) {
        var originFunc = console[level];
        console[level] = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (enabled) {
                var message = safeJoin(args, ' ');
                if (level === 'assert') {
                    if (args[0] === false) {
                        message = "Assertion failed: ".concat(safeJoin(args.slice(1), ' ') || 'console.assert');
                    }
                    else {
                        return;
                    }
                }
                etracker.log('console', {
                    p1: level,
                    p2: message,
                });
            }
            originFunc && originFunc.apply(console, args);
        };
        // @ts-ignore
        etracker._originConsoleMethods[level] = originFunc;
    });
    var enable = function () {
        enabled = true;
    };
    var disable = function () {
        enabled = false;
    };
    return {
        enableConsole: enable,
        disableConsole: disable,
    };
}

export { ETrackerPluginConsole as default };
